import {Injectable} from '@angular/core';
import {RequestExecutor} from '../../util/request-executor';

@Injectable()
export class ShipmentService {
  constructor(private request: RequestExecutor) {
  }

  deleteShipment(id: string) {
    return this.request.delete('/shipment', {id: id});
  }

  deleteShipments(orderIds: string[]) {
    return this.request.post('/order/delete/batch', {OrderIds: orderIds});
  }


  unassignShipments(orderIds: string[]) {
    return this.request.post('/order/unassign/batch', {OrderIds: orderIds});
  }

  getFilterableOrderStatuses() {
    return ['Unassigned', 'Offer', 'Started', 'Finished'];
  }
}
